import styles from "./MultiContainer.module.scss";

export const MultiContainer = (props) => {
  const { children, className = "", inner = false } = props;

  const containerClass = inner ? styles.innerContainer : styles.container;

  return <div className={`${containerClass} ${className}`}>{children}</div>;
};
